import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RechazarSolComponent } from "./components/rechazar-sol/rechazar-sol.component";
import { EditarSolComponent } from "./components/editar-sol/editar-sol.component";
import { HeaderMainComponent } from "./layout/header-main/header-main.component";
import { MenuUserComponent } from "./layout/menu-user/menu-user.component";
import { MenuMainComponent } from "./layout/menu-main/menu-main.component";

@NgModule({
  declarations: [
    RechazarSolComponent,
    EditarSolComponent,
    HeaderMainComponent,
    MenuUserComponent,
    MenuMainComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    HeaderMainComponent,
    MenuUserComponent,
    MenuMainComponent
  ]
})
export class SharedModule { }
